var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationsBell({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.75V15.75H2V8.74999C2 7.36666 2.41667 6.13749 3.25 5.06249C4.08333 3.98749 5.16667 3.28333 6.5 2.94999V2.24999C6.5 1.83333 6.64583 1.47916 6.9375 1.18749C7.22917 0.895826 7.58333 0.749992 8 0.749992C8.41667 0.749992 8.77083 0.895826 9.0625 1.18749C9.35417 1.47916 9.5 1.83333 9.5 2.24999V2.94999C10.8333 3.28333 11.9167 3.98749 12.75 5.06249C13.5833 6.13749 14 7.36666 14 8.74999V15.75H16V17.75H0ZM8 20.75C7.45 20.75 6.97917 20.5542 6.5875 20.1625C6.19583 19.7708 6 19.3 6 18.75H10C10 19.3 9.80417 19.7708 9.4125 20.1625C9.02083 20.5542 8.55 20.75 8 20.75ZM4 15.75H12V8.74999C12 7.64999 11.6083 6.70833 10.825 5.92499C10.0417 5.14166 9.1 4.74999 8 4.74999C6.9 4.74999 5.95833 5.14166 5.175 5.92499C4.39167 6.70833 4 7.64999 4 8.74999V15.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsBell);
export default __webpack_public_path__ + "static/media/notifications-bell.5e4e820801e5399037e6852eecbdb340.svg";
export { ForwardRef as ReactComponent };